<!--
2023-08-17 YTW Vip体系
-->
<template>
  <div class="main-content">
    <div class="first-boxes-container" :style="{backgroundImage:'url('+require('../../assets/images/vip/v_back.svg')+')'}">
      <div class="top">
        <div style="width: 15vw"><TopBack id="TopBack" style="margin-left: -12px"/></div>
        <div class="title" style="width: 70vw">{{ $t('lang.VIP.myVIPBenefits') }}</div>
        <div style="width: 15vw;height: 1px"></div>
      </div>
      <div class="swiperBox">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item,index) in benefitsList" :key="index">
              <div class="img-box">
                <div :class="item.isDark?'middle-box dark':'middle-box'"
                     :style="{backgroundImage:'url('+require('../../assets/images/vip/b'+index+'.svg')+')'}">
                </div>
                <div class="bottom-line">
                  {{item.value}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-button-prev" @click="prev"><img :src="goPrev"></div>
        <div class="swiper-button-next" @click="next"><img :src="goNext"></div>
      </div>
    </div>
    <div class="middle-boxes-container">
      <div class="getGiftBox-before"></div>
      <div class="getGiftBox">
        <div class="getGiftBox-top">
          <div>
            <p class="levelUp">{{ benefitsList[levelIndex].value }}</p>
            <p class="levelUpDesc"><span>{{ benefitsList[levelIndex].desc }}</span></p>
          </div>
        </div>
        <div class="getGiftBox-center">
          <div class="getGiftBox-row">
            <div class="text" v-if="benefitsList[levelIndex].mode!==3">
              <p v-if="benefitsList[levelIndex].mode===1">{{ $t('lang.VIP.currentlyAvailable') }}</p>
              <p v-if="benefitsList[levelIndex].mode===2">{{ $t('lang.VIP.currentRebateRate') }}</p>
              <p v-if="benefitsList[levelIndex].mode===4">{{ $t('lang.VIP.extraTimes1') }}</p>
              <p v-if="benefitsList[levelIndex].mode===4">{{ $t('lang.VIP.extraTimes2') }}</p>
              <p v-if="benefitsList[levelIndex].mode===5">{{ $t('lang.VIP.unavailable1') }}</p>
              <p v-if="benefitsList[levelIndex].mode===5">{{ $t('lang.VIP.unavailable2') }}</p>
            </div>
            <div class="amount" v-if="benefitsList[levelIndex].mode!==3">
              <p
                v-if="benefitsList[levelIndex].mode===1||benefitsList[levelIndex].mode===2||benefitsList[levelIndex].mode===4">
                {{ benefitsList[levelIndex].amountShow }}
              </p>
            </div>
            <div class="item-btn" v-if="benefitsList[levelIndex].mode===1" @click="getGifts">
              {{ $t('lang.VIP.getItNow') }}
            </div>
            <div class="birth" v-if="!birthday&& levelIndex===7">
              <div class="text birth-text" style="letter-spacing: -0.035em" v-if="benefitsList[levelIndex].mode===3">
                <p>{{ $t('lang.VIP.birthdayReminder') }}</p>
              </div>
              <div class="item-btn" style="font-size: 16px;line-height: 11.44vw"
                   @click="goto('Edit')">
                {{ $t('lang.VIP.go') }}
              </div>
            </div> <!--未填写生日-->
            <div class="birth" v-else>
              <div class="tel-area" style="font-size: 16px;line-height: 21px"
                   v-if="benefitsList[levelIndex].mode===3&&(currentLevel>5||levelIndex!==7)">
                <img :src="tel"/>
                <span class="text">{{ phoneNum }}</span>
                <img :src="copy" @click="copyNum"/>
              </div>
              <div class="item-btn" style="font-size: 16px;line-height: 21px"
                   v-if="benefitsList[levelIndex].mode===3&&(currentLevel>5||levelIndex!==7)"
                   @click="isModalShowing=true">
                {{ $t('lang.VIP.customerService') }}
              </div>
              <div class="text birth-text" style="letter-spacing: -0.035em"
                   v-if="benefitsList[levelIndex].mode===3&&currentLevel===5&&levelIndex===7">
                <p>{{ $t('lang.VIP.chat') }}</p>
              </div>
              <div class="item-btn" style="font-size: 16px;"
                   v-if="benefitsList[levelIndex].mode===3&&currentLevel===5&&levelIndex===7"
                   @click="handleOpenChat">
                {{ $t('lang.VIP.go') }}
              </div>
            </div>
            <div class="item-btn" style="background: rgba(0,0,0,0)"
                 v-if="benefitsList[levelIndex].mode===2"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-boxes">
      <div class="bottom-title">
        <img :src="rule1">
        <div>{{ $t('lang.VIP.rule') }}</div>
        <img :src="rule2">
      </div>
      <div class="bottom-table">
        <table>
          <thead>
          <tr>
            <th>VIP1</th>
            <th>VIP2</th>
            <th>VIP3</th>
            <th>VIP4</th>
            <th>VIP5</th>
            <th>VIP6</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in vipList" :key="index">
            <td>{{ item.name1 === true ? 'Yes' : (item.name1 === false ? 'No' : item.name1) }}</td>
            <td>{{ item.name2 === true ? 'Yes' : (item.name2 === false ? 'No' : item.name2) }}</td>
            <td>{{ item.name3 === true ? 'Yes' : (item.name3 === false ? 'No' : item.name3) }}</td>
            <td>{{ item.name4 === true ? 'Yes' : (item.name4 === false ? 'No' : item.name4) }}</td>
            <td>{{ item.name5 === true ? 'Yes' : (item.name5 === false ? 'No' : item.name5) }}</td>
            <td>{{ item.name6 === true ? 'Yes' : (item.name6 === false ? 'No' : item.name6) }}</td>
          </tr>
          </tbody>
        </table>
        <table>
          <thead>
          <tr>
            <th>&nbsp;VIP7&nbsp;</th>
            <th>&nbsp;VIP8&nbsp;</th>
            <th>&nbsp;VIP9&nbsp;</th>
            <th>VIP10</th>
            <th>VIP11</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in vipList2" :key="index">
            <td>{{ item.name1 === true ? 'Yes' : (item.name1 === false ? 'No' : item.name1) }}</td>
            <td>{{ item.name2 === true ? 'Yes' : (item.name2 === false ? 'No' : item.name2) }}</td>
            <td>{{ item.name3 === true ? 'Yes' : (item.name3 === false ? 'No' : item.name3) }}</td>
            <td>{{ item.name4 === true ? 'Yes' : (item.name4 === false ? 'No' : item.name4) }}</td>
            <td>{{ item.name5 === true ? 'Yes' : (item.name5 === false ? 'No' : item.name5) }}</td>
          </tr>
          </tbody>
        </table>
        <div class="rules" v-html="vipRules"></div>
      </div>
    </div>
    <div class="modal" v-if="isModalShowing">
      <div class="content">
        <div class="claimedTitle">
          {{ $t('lang.VIP.customerService') }}
        </div>
        <div class="tips">
          <div class="phoneNum">
            <img :src="phone">
            <div>{{phoneNum}}</div>
          </div>
          <div class="copyNum" @click="copyNum">{{$t('lang.inviteFriends.copy')}}</div>
          <div class="addNum" @click="addNum">{{$t('lang.inviteFriends.add')}}</div>
        </div>
        <button @click="isModalShowing=false">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/service'
import TopBack from '@/components/TopBack/index'
import Swiper from 'swiper'
import star from '@/assets/images/vip/star.svg'
import phone from '@/assets/images/invite/phone.png'
import rule1 from '@/assets/images/vip/rule1.svg'
import rule2 from '@/assets/images/vip/rule2.svg'
import left from '@/assets/images/vip/left.svg'
import goPrev from '@/assets/images/vip/goPrev.svg'
import goNext from '@/assets/images/vip/goNext.svg'
import copy from '@/assets/images/vip/copy.svg'
import tel from '@/assets/images/vip/tel.svg'
import {Swipe, SwipeItem, Toast} from 'mint-ui'
import axios from 'axios'

export default {
  name: 'vip',
  computed: {
  },
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      isModalShowing: false,
      vipRules: '',
      phoneNum: '',
      vipList: [
        {name1: '1', name2: '2', name3: '3', name4: '4', name5: '5', name6: '6'},
        {name1: ' ', name2: ' ', name3: ' ', name4: ' ', name5: ' ', name6: ' '}
      ],
      vipList2: [
        {name1: '7', name2: '8', name3: '9', name4: '10', name5: '11'},
        {name1: ' ', name2: ' ', name3: ' ', name4: ' ', name5: ' '}
      ],
      currentLevel: 0,
      levelIndex: 0,
      balanceNotEnoughHint: this.$t('lang.home.creditNotEnough'),
      gameInfo: {},
      playGame: false,
      showGame: false,
      swiper: {},
      benefitsList: this.$t('lang.VIP.benefitsList'),
      vipInfo: {},
      vipSetting: [],
      goPrev,
      goNext,
      phone,
      rule1,
      rule2,
      star,
      left,
      copy,
      tel,
      birthday: null
    }
  },
  components: {
    Swipe,
    SwipeItem,
    TopBack
  },
  watch: {
    '$store.state.locale': function () {
      this.benefitsList = this.$t('lang.VIP.benefitsList')
      this.getPrevData()
      this.levelIndex = this.swiper.activeIndex
      this.fetchRule()
    }
    // 'sessionStorage.Birthday': function () {
    //   this.birthday = sessionStorage.Birthday
    // }
  },
  mounted () {
    this.birthday = sessionStorage.Birthday
    this.getPrevData()
    this.fetchRule()
    let that = this
    this.swiper = new Swiper('.swiper-container', {
      direction: 'horizontal', // 滑动方向，可设置水平(horizontal)或垂直(vertical)。
      loop: false, // 设置为true 则开启loop模式
      autoplay: false, // 自动切换时间
      slidesPerView: 'auto', // 设置slider容器能够同时显示的slides数量(carousel模式)。类型：number or auto
      centeredSlides: true, // 设定为true时，active slide会居中，而不是默认状态下的居左。
      spaceBetween: 0, // 在slide之间设置距离（单位px）。
      initialSlide: that.levelIndex,
      loopAdditionaSlider: 1, // loop模式下会在slides前后复制若干个slide,，前后复制的个数不会大于原总个数。
      navigation: { // 左右按钮
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      on: {
        slideChangeTransitionStart: function (e) {
          that.levelIndex = e.activeIndex
          that.fetchVipList(that.levelIndex)
        }
      }
    })
    that.levelIndex = this.swiper.activeIndex
    that.fetchVipList(that.levelIndex)
  },
  updated () {
  },
  methods: {
    fetchVipList (n) {
      let propertyName = ''
      switch (n) {
        case 0 :
          propertyName = 'UpVipReward'
          break
        case 1 :
          propertyName = 'Card'
          break
        case 2 :
          propertyName = 'SlotGames'
          break
        case 3 :
          propertyName = 'FishingGames'
          break
        case 4 :
          propertyName = 'SportsGames'
          break
        case 5 :
          propertyName = 'LiveCasino'
          break
        case 6 :
          propertyName = 'Crash'
          break
        case 7 :
          propertyName = 'BirthdayGift'
          break
        case 8 :
          propertyName = 'WeekReward'
          break
        case 9 :
          propertyName = 'Promotion'
          break
        case 10 :
          propertyName = 'CustomerManager'
          break
        case 11 :
          propertyName = 'WithdrawCount'
          break
        case 12 :
          propertyName = 'FestivalGift'
          break
      }
      for (let i = 1; i < 7; i++) {
        this.vipList[1]['name' + i] = this.vipSetting[i][propertyName]
      }
      for (let j = 1; j < 6; j++) {
        this.vipList2[1]['name' + j] = this.vipSetting[j + 6][propertyName]
      }
      // for (let i = 1; i < 6; i++) {
      //   this.vipList[1]['name' + i] = this.vipSetting[i][propertyName]
      // }
      // for (let j = 1; j < 5; j++) {
      //   this.vipList2[1]['name' + j] = this.vipSetting[j + 5][propertyName]
      // }
    },
    getPrevData () {
      if (!this.userInfo || !this.userInfo.UserId) {
        this.$router.push('/Login')
        return
      }
      this.vipInfo = JSON.parse(localStorage.getItem('vipInfo'))
      this.vipSetting = JSON.parse(localStorage.getItem('vipSetting'))
      this.currentLevel = this.vipInfo.VipLevel
      this.levelIndex = this.vipInfo.currentIndex
      this.phoneNum = this.vipInfo.phoneNum
      if (this.vipInfo.UpVipReward > 0) {
        this.benefitsList[0].isDark = false
        this.benefitsList[0].mode = 1
        this.benefitsList[0].amountShow = this.$t('lang.account.currencyType') + this.vipInfo.Level2Reward
      }
      if (this.vipInfo.Card.replace('%', '') * 1 !== 0) {
        this.benefitsList[1].isDark = false
        this.benefitsList[1].mode = 2
        this.benefitsList[1].amountShow = this.vipInfo.Card
      }
      if (this.vipInfo.SlotGames.replace('%', '') * 1 !== 0) {
        this.benefitsList[2].isDark = false
        this.benefitsList[2].mode = 2
        this.benefitsList[2].amountShow = this.vipInfo.SlotGames
      }
      if (this.vipInfo.FishingGames.replace('%', '') * 1 !== 0) {
        this.benefitsList[3].isDark = false
        this.benefitsList[3].mode = 2
        this.benefitsList[3].amountShow = this.vipInfo.FishingGames
      }
      if (this.vipInfo.SportsGames.replace('%', '') * 1 !== 0) {
        this.benefitsList[4].isDark = false
        this.benefitsList[4].mode = 2
        this.benefitsList[4].amountShow = this.vipInfo.SportsGames
      }
      if (this.vipInfo.LiveCasino.replace('%', '') * 1 !== 0) {
        this.benefitsList[5].isDark = false
        this.benefitsList[5].mode = 2
        this.benefitsList[5].amountShow = this.vipInfo.LiveCasino
      }
      if (this.vipInfo.Crash.replace('%', '') * 1 !== 0) {
        this.benefitsList[6].isDark = false
        this.benefitsList[6].mode = 2
        this.benefitsList[6].amountShow = this.vipInfo.Crash
      }
      if (this.vipInfo.BirthdayGift) {
        this.benefitsList[7].isDark = false
        this.benefitsList[7].mode = 3
      }
      if (this.vipInfo.WeekReward > 0) {
        this.benefitsList[8].isDark = false
        this.benefitsList[8].mode = 1
        this.benefitsList[8].amountShow = this.$t('lang.account.currencyType') + this.vipInfo.Week2Reward
      }
      if (this.vipInfo.Promotion) {
        this.benefitsList[9].isDark = false
        this.benefitsList[9].mode = 3
      }
      if (this.vipInfo.CustomerManager) {
        this.benefitsList[10].isDark = false
        this.benefitsList[10].mode = 3
      }
      if (this.vipInfo.WithdrawCount > 0) {
        this.benefitsList[11].isDark = false
        this.benefitsList[11].mode = 4
        this.benefitsList[11].amountShow = this.vipInfo.WithdrawCount + this.$t('lang.VIP.times')
      }
      if (this.vipInfo.FestivalGift) {
        this.benefitsList[12].isDark = false
        this.benefitsList[12].mode = 3
      }
    },
    prev () {
      this.swiper.slidePrev()
    },
    next () {
      this.swiper.slideNext()
    },
    goto (path) {
      let vipInfoBeforeGoto = JSON.parse(localStorage.vipInfo)
      vipInfoBeforeGoto.currentIndex = this.levelIndex
      localStorage.vipInfo = JSON.stringify(vipInfoBeforeGoto)
      this.$router.push('/' + path)
    },
    getGifts () {
      // 领取升级奖金
      if (this.levelIndex === 0) {
        if (this.vipInfo.Level2Reward > 0) {
          request('post', 'innovation/vip/collect_level_reward', {UserId: this.userInfo.UserId}, false).then(res => {
            if (res !== -1) {
              this.vipInfo.Level2Reward = 0
              this.benefitsList[0].amountShow = this.$t('lang.account.currencyType') + this.vipInfo.Level2Reward
              localStorage.setItem('vipInfo', JSON.stringify(this.vipInfo))
              Toast(this.$t('lang.VIP.getOk'))
            }
          })
        } else {
          Toast(this.$t('lang.VIP.noGifts'))
        }
      } else if (this.levelIndex === 8) {
        if (this.vipInfo.Week2Reward > 0) {
          request('post', 'innovation/vip/collect_week_reward', {UserId: this.userInfo.UserId}, false).then(res => {
            if (res !== -1) {
              this.vipInfo.Week2Reward = 0
              this.benefitsList[8].amountShow = this.$t('lang.account.currencyType') + this.vipInfo.Week2Reward
              localStorage.setItem('vipInfo', JSON.stringify(this.vipInfo))
              Toast(this.$t('lang.VIP.getOk'))
            }
          })
        } else {
          Toast(this.$t('lang.VIP.noGifts'))
        }
      }
    },
    copyNum () {
      let shares = this.phoneNum
      let copyBehavior = function (e) {
        e.clipboardData.setData('text/plain', shares)
        e.preventDefault() // 阻止默认行为
      }
      document.addEventListener('copy', copyBehavior)
      document.execCommand('copy')
      Toast(this.$t('lang.inviteFriends.success'))
    },
    addNum () {
      window.open('http://wa.me/' + this.phoneNum, '_blank')
    },
    fetchRule () {
      let languagePre = this.$store.state.locale
      languagePre = languagePre === 'EN' ? '' : '-' + languagePre
      const htmlFileURL = location.origin + '/static/promotionRules/vipRule-' + this.$store.state.internation + languagePre + '.html'
      axios.get(htmlFileURL).then(res => {
        if (res.data != null) {
          this.vipRules = res.data
        }
      })
    },
    handleOpenChat () {
      if (this.userInfo && this.userInfo.UserShowId) {
        window.LiveChatWidget.call('set_customer_name', this.userInfo.UserShowId)
      } else {
        window.LiveChatWidget.call('set_customer_name', ' ')
      }
      window.LiveChatWidget.call('maximize')
    }
  }
}
</script>

<style lang="less" scoped>
.main-content {
  height: 100vh;
  display: flex;
  background-color: #1E1E1E;
  flex-direction: column;
  padding: 56px 0 70px 0;
  overflow-x: hidden;

  .dark {
    filter: brightness(25%);
  }
  .first-boxes-container {
    position: relative;
    top: -2vw;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top;
    width: 100vw;
    padding-top: 3vw;
    .top {
      display: flex;
      height: 15vw;
      align-items: flex-start;
      width: 100vw;
      .title {
        margin-top: 8px;
        text-align: center;
        font-size: 18px;
        line-height: 30px;
        color: #000000;
        font-weight: 700;
      }
    }

    .swiperBox {
      position: relative;
      top: -4.5vw;
      height: 32vw;
      display: flex;
      .swiper-button-prev{
        position: absolute;
        left: 2vw;
        top: 3vh;
        z-index: 2;
        img{
          width: 15px;
        }
      }
      .swiper-button-next{
        position: absolute;
        right: 2vw;
        top: 3vh;
        z-index: 2;
        img{
          width: 15px;
        }
      }
      .swiper-button-prev::after{
        display: none;
      }
      .swiper-button-next::after{
        display: none;
      }
      .swiper-container {
        margin: auto;
        display: flex;
        width: 84vw;
        height: 100%;
      }
      .swiper-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        display: -webkit-box;
        display: -ms-flexbox;
        -webkit-transition-property: -webkit-transform;
        transition-property: -webkit-transform;
        transition-property: transform;
        transition-property: transform, -webkit-transform;
        -webkit-box-sizing: content-box;
        box-sizing: content-box;
      }

      .swiper-slide {
        margin: 2vw 2vw;
        width: 28vw !important;
        height: 100%;
        overflow: hidden;
        .img-box {
          margin: auto;
          width: 100%;
          height: 15vh;
          border-radius: 5px;
          .middle-box{
            background-repeat: no-repeat;
            background-size: 100% 100%;
            height: 7.6vh;
          }
        }
        .bottom-line {
          margin: auto;
          width: 100%;
          text-align: center;
          font-size: 3.6vw;
          line-height: 3.6vw;
          font-weight: 700;
          color: #000000;
          overflow-wrap: break-word;
        }
      }
      .swiper-slide-active {
        margin-top: 1.6vh;
        .middle-box{
          background-repeat: no-repeat;
          background-size: 100% 100%;
          height: 8.3vh !important;
        }
        .bottom-line {
          margin: auto;
          width: 100%;
          text-align: center;
          font-size: 13px;
          font-weight: 700;
          line-height: 13px;
          color: #000000;
          overflow-wrap: break-word;
        }
      }
    }
  }
  .middle-boxes-container {
    position: relative;
    height: max-content;
    .getGiftBox {
      position: absolute;
      left: 2.5vw;
      top: 3.5vh;
      border-radius: 17px;
      width: 95vw;
      height: 63.95vw;
      background: #262626;
      border: 1px solid #A6A6A6;
      z-index: 0;
      .getGiftBox-top {
        position: relative;
        display: flex;
        width: 100%;
        height: max-content;
        text-align: center;
        justify-content: center;
        align-items: center;
        .levelUp {
          position: relative;
          left: 50%;
          transform: translate(-50%);
          letter-spacing: -0.008em;
          width: 100%;
          background: linear-gradient(to bottom, #E8C784, #CBCBCB);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          font-size: 6vw;
          font-weight: 700;
          margin-top: 3vw;
        }

        .levelUpDesc {
          position: relative;
          top: -0.5vw;
          left: 50%;
          transform: translate(-50%);
          display: flex;
          align-items: center;
          height: 8.6vw;
          font-size: 3.6vw;
          font-weight: 400;
          color: #808080;
        }
      }
      .getGiftBox-center{
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        bottom: 2.46vw;
        display: flex;
        background-color: #2F2F2F;
        border-radius: 8px;
        width: 90vw;
        height: 43vw;
        justify-content: center;
        .getGiftBox-row {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          text-align: center;
          padding: 4vw 0 2.5vw 0;
          .amount {
            width: 90vw;
            font-weight: 700;
            font-size: 38px;
            line-height: 44px;
            background: linear-gradient(180deg, #FFF8BA 43.26%, #FFFFFF 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }

          .text {
            width: 90vw;
            font-size: 22px;
            font-weight: 700;
            line-height: 23px;
            background: linear-gradient(180deg, #DAAC69 0%, #F1E0C7 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            p {
              margin: 8px 0;
            }
          }

          .birth-text {
            margin-bottom: 22px;
          }

          .item-btn {
            margin: auto;
            line-height: 11.44vw;
            width: 54.8vw;
            height: 11.44vw;
            border-radius: 2px;
            font-size: 18.4px;
            font-weight: 700;
            background: linear-gradient(90.83deg, #D7A756 -1.31%, #F2CF95 108.48%);
            color: #000000;
            z-index: 1;
          }

          .tel-area {
            margin: 3vw auto 5vw auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 60vw;
            z-index: 1;
            img{
              height: 18px;
            }
            .text {
              font-size: 18px;
              line-height: 18px;
              font-weight: 700;
              letter-spacing: 0.05em;
              width: max-content;
              background-image: linear-gradient(180deg, #DDB77F 0%, #F1E0C7 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              border-bottom: 2px solid #DDB77F;
            }
          }

          div {
            min-height: max-content;
          }
        }
      }
    }
    .getGiftBox-before {
      position: absolute;
      top: calc(3.5vh - 11px);
      left: calc(50vw - 10px);
      content: "";
      border-left: 1px solid #A6A6A6;
      border-top: 1px solid #A6A6A6;
      height: 22px;
      width: 22px;
      background: #262626;
      transform: rotate(45deg);
      z-index: 1;
    }
  }
  .bottom-boxes{
    margin: calc(63.95vw + 7vh) auto 0 auto;
    width: 100vw;
    z-index: 0;
    .bottom-title {
      margin-bottom: 2.5vh;
      display: flex;
      justify-content: center;
      img{
        height: 32px;
      }

      div {
        margin: auto 4vw;
        font-size: 34px;
        font-weight: 700;
        line-height: 32px;
        text-align: left;
        background: linear-gradient(180deg, #FFEDDB 0%, #F1CFAA 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .bottom-table{
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
      background-color: #FFFFFF;
      padding: 5px 0 26px 0;
      table {
        margin: 2vh auto;
        width: 85%;
        border-collapse: collapse;
        border: 2px solid #090909;
        td {
          text-align: center;
          height: 3.5vh;
          border: 2px solid #090909;
          color: #212121;
        }
        th{
          text-align: center;
          height: 3.5vh;
          border: 2px solid #141414;
          background-color: #2E2E2E;
          color: #FFFFFF;
        }
        tr:nth-child(odd) td:nth-of-type(odd),
        tr:nth-child(even) td:nth-of-type(even) {
          background-color: #F5F1EC;
        }
      }

      div{
        text-align: center;
        font-size: 17px;
        font-weight: 500;
        line-height: 28px;
        color: #636363;
      }
    }
  }
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0,0,0,0.7);
    z-index: 999;

    .content {
      position:absolute;
      top: 0;
      left:0;
      right:0;
      bottom:0;
      width: 88vw;
      height: 28.61vh;
      padding: 24px;
      background: #1c1c1e;
      border: #737373 2px solid;
      border-radius: 15px;
      margin: auto;
      display: flex;
      flex-wrap: wrap;
      .claimedTitle {
        margin: auto;
        width: 100%;
        font-size: 4.2vw;
        font-weight: 700;
        background-image: linear-gradient(99.1deg, #F9DCA7 5.72%, #EBDDC4 35.98%, #DAB470 102.55%);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
      }

      .claimResult {
        width: 100%;
        margin: 3.28vh 0;
        font-size: 2.6vh;
        font-weight: 400;
        color: #ffffff;
        line-height: 2.66vh;
      }
      .claimResultLarge {
        width: 100%;
        margin: 0.28vh 0 1.28vh 0;
        font-size: 2.6vh;
        font-weight: 400;
        color: #ffffff;
        line-height: 2.66vh;
      }

      .tips {
        display: flex;
        width: 100vw;
        margin: 1.2vh 0vw;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        height: 4.1vh;
        .phoneNum {
          font-size: 4.5vw;
          font-weight: 400;
          text-align: center;
          color: rgba(183, 183, 183, 1);
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 2.5vh;
            height: 2.5vh;
          }
          div{
            margin-left: 2.5vw;
            line-height: 4vh;
          }
        }
        .copyNum{
          font-size: 2vh;
          font-weight: 400;
          line-height: 3.5vh;
          text-align: center;
          color: rgba(233, 206, 160, 1);
          margin-left: 3.5vw;
          text-decoration: underline;
        }
        .addNum{
          font-size: 2vh;
          font-weight: 400;
          line-height: 3.5vh;
          text-align: center;
          color: rgba(43, 153, 255, 1);
          margin-left: 3.5vw;
          text-decoration: underline;
        }
      }

      button {
        position: relative;
        left: 50%;
        transform: translate(-50%);
        height: 6.13vh;
        width: 70.72vw;
        background-color: #f1dab0;
        border: none;
        border-radius: 8px;
        color: #220303;
        font-size: 2.85vh;
        font-weight: 700;
        line-height: 2.85vh;
        text-align: center;
      }

      .cancel {
        width: 100%;
        margin-top: 22px;
        text-align: center;
        font-size: 20px;
        font-weight: 400;
        color: #696969;
      }
    }
  }
  .rules {
    width: 85vw;
    margin: 5px auto 20px;
    overflow: hidden;
    text-align: left;
  }
}
.main-content::-webkit-scrollbar {
  display: none
}

</style>



// WEBPACK FOOTER //
// src/pages/VipBenefits/index.vue